module.exports = "/fonts/vendor/vue-pdf-app/dist/icons/pdf.eot?2c5394094daa1c985564b87cad215436";